import React from "react";

// styles
import styles from "./Blogs.module.css";

// img
import arrowIcon from "../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import { Link } from "react-router-dom";
import BlogsSlider from "./BlogsSlider";
// import BlogMobileSize from './BlogMobileSize';

const Blogs = props => {
  // let width = window.innerWidth;
  return (
    <>
      <div className="container-fluid">
        <div className="w-100 d-flex justify-content-center flex-wrap align-items-center mt-3 me-3 px-5" dir="rtl">
          <div className="container d-flex align-items-center justify-content-center px-0 flex-column">
            <div className="w-100 d-flex align-items-center justify-content-between">
              <h2 className={styles.title}>بلاگ</h2>
              <Link to="/وبلاگ" className={styles.text_primary}>
                مشاهده بیشتر
                <img className="me-2" src={arrowIcon} alt="icon" />
              </Link>
            </div>

            <div className="container d-flex justify-content-center flex-wrap align-items-center my-3 px-0" dir="ltr">
              <BlogsSlider blogsData={props.blogsData} />
              {/* {width > 768 ?
                                :
                                <BlogMobileSize blogsData={props.blogsData} />
                            } */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
